import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { LogoNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Logo';
import { Logout } from 'Components/ClientApp/CombinedApp/Navigation/TopNav/Logout';
import {
  ReferralPageNavButton,
} from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/ReferralPageNavButton';
import { PlanningNavButton } from '../HydratedNavButtons/Planning';
import { InvestmentsNavButton } from '../HydratedNavButtons/Investments';
import { MessagesNavButton } from '../HydratedNavButtons/Messages';
import { ProfileNavButton } from '../HydratedNavButtons/Profile';
import { NotificationsNavButton } from '../HydratedNavButtons/Notifications';

export const ClientNavCPC = () => {
  // BE CAREFUL ADJUSTING THIS FILE!
  // EVEN THE SLIGHTEST ADJUSTMENT CAN CAUSE THE UI TO WRAP AT ITS MOBILE BREAKPOINT (960px at time of writing)
  return (
    <>
      <FDStack alignItems="center">
        <LogoNavButton />
        <PlanningNavButton />
        <InvestmentsNavButton />
        <MessagesNavButton />
        <ReferralPageNavButton />
      </FDStack>
      <FDStack alignItems="center">
        <ProfileNavButton />
        <NotificationsNavButton />
        <Logout />
      </FDStack>
    </>
  );
};
